import { APIURL } from "../../constantes.js";
import { AlumnoDTO } from "../DTOS/Alumno.dto.js";

export class AlumnosServicio {
    async ObtenerAlumnos() {
        const tokenLogin = localStorage.getItem("token");
        const respuesta = await fetch(`${APIURL}/alumnos/`, {
            headers: {
                "Authorization": `Bearer ${(tokenLogin === undefined) ? "" : tokenLogin}`,
                "Content-Type": "application/json",
            },
            method: "GET",
            mode: "cors",
        }).then((response) => response.json());

        if (respuesta.error) {
            alert(respuesta.error);
            return [];
        }

        return respuesta.map(value => {
            const dto = new AlumnoDTO();
            dto.cargarDTO(value);
            return dto;
        });
    }

    async ObtenerAlumno(id) {
        const tokenLogin = localStorage.getItem("token");
        const respuesta = await fetch(`${APIURL}/alumnos/${id}`, {
            headers: {
                "Authorization": `Bearer ${(tokenLogin === undefined) ? "" : tokenLogin}`,
                "Content-Type": "application/json",
            },
            method: "GET",
            mode: "cors",
        }).then((response) => response.json());

        if (respuesta.error) {
            alert(respuesta.error);
            return new AlumnoDTO();
        }

        const dto = new AlumnoDTO();
        dto.cargarDTO(respuesta);
        return dto;
    }

    async AgregarCarreraAlumno(id) {
        const tokenLogin = localStorage.getItem("token");
        const respuesta = await fetch(`${APIURL}/alumnos/${id}/agregarcarrera`, {
            body: JSON.stringify({
            }),
            headers: {
                "Authorization": `Bearer ${(tokenLogin === undefined) ? "" : tokenLogin}`,
                "Content-Type": "application/json",
            },
            method: "POST",
            mode: "cors",
        }).then((response) => response.json());

        if (respuesta.error) {
            alert(respuesta.error);
            return new AlumnoDTO();
        }

        const dto = new AlumnoDTO();
        dto.cargarDTO(respuesta);
        return dto;
    }

    async AgregarAlumno(alumno) {
        const tokenLogin = localStorage.getItem("token");
        const respuesta = await fetch(`${APIURL}/alumnos/`, {
            body: JSON.stringify({
                alumno : JSON.stringify(alumno),
            }),
            headers: {
                "Authorization": `Bearer ${(tokenLogin === undefined) ? "" : tokenLogin}`,
                "Content-Type": "application/json",
            },
            method: "POST",
            mode: "cors",
        }).then((response) => response.json());

        if (respuesta.error) {
            alert(respuesta.error);
            return new AlumnoDTO();
        }

        const dto = new AlumnoDTO();
        dto.cargarDTO(respuesta);
        return dto;
    }

}
